module.exports = {
  name: 'Svenska',
  key: 'sv',
  'Open in Debug Map': 'Öppna i Debug Map',
  'Open in Mapillary': 'Öppna i Mapillary',
  'GPX': 'Export GPX file',
  'Open in editor': 'Öppna i redigerare',
  'Open in JOSM': 'Öppna i JOSM',
  'Select language': 'Välj språk',
  'Share Route': 'Dela rutt',
  'Link': 'Länk',
  'Shortlink': 'Kortlänk',
  'Start - press enter to drop marker': 'Start - tryck för att placera startpunkt',
  'End - press enter to drop marker': 'Mål - tryck för att placera slutpunkt',
  'Via point - press enter to drop marker': 'Via - tryck för att placera delmålspunkt',
  'Build': 'Build: '
};
